if (!customElements.get("pq-card-product")) {
  customElements.define(
    "pq-card-product",
    class pqCardProduct extends HTMLElement {
      constructor() {
          super();
      }
      connectedCallback() {
         this.quickViewClick();
         document.querySelector('.transition-body').addEventListener('click', () => {
          document.body.classList.remove('quick-view--open');
          const el = document.querySelector('.quick-view-drawer-details');
          window.pq.scrollEnable();
          if (el) {
            el.removeAttribute('open');
            el.classList.remove('menu-opening');
          }
          

         });
      }
      quickViewClick() {
        const quickViewElement = this.querySelector('.card-item-tag-quick-view');
        const button = this.querySelector('.custom-dark-button-card');
      
        // 点击标签打开 quick view
        if (quickViewElement) {
          quickViewElement.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();   
            const urlFromAttr = quickViewElement.getAttribute('data-product-url') || '';
            let productUrl = '';
            
            if (urlFromAttr.includes('/products')) {
              productUrl = urlFromAttr;
            } else {
              productUrl = `/products/${urlFromAttr}`;
            }
            
            productUrl += '?view=modal';
            this.quickViewOpen(productUrl);
          });
        }
      
        // 点击按钮打开 quick view（根据 variantSize 判断）
        if (button && quickViewElement) {
          button.addEventListener('click', (e) => {
            const urlFromAttr = quickViewElement.getAttribute('data-product-url') || '';
            let productUrl = '';
            
            if (urlFromAttr.includes('/products')) {
              productUrl = urlFromAttr;
            } else {
              productUrl = `/products/${urlFromAttr}`;
            }
            
            productUrl += '?view=modal';
            const variantSize = parseInt(button.getAttribute('data-variant-size'), 10);
      
            if (variantSize > 1) {
            
              this.quickViewOpen(productUrl);
            }
          });
        }
      }
      
      quickViewOpen(productUrl) {
          const drawerContent = document.querySelector('#global-product-card-popup');
         
          fetch(productUrl)
          .then(response => response.text())
          .then(responseText => {
            document.body.classList.add('quick-view--open');
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('.quick-view-drawer');
            const productElementDetails = productElement.querySelector('.quick-view-drawer-details');

            productElementDetails.setAttribute('open', '');
            productElementDetails.classList.add('menu-opening');
            document.querySelector('.header-01').classList.add('header-01-out');
            document.querySelector('#header-01').classList.add('header-01-out');
            drawerContent.innerHTML = productElement.innerHTML;
            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            window.pq.scrollDisable();
            setTimeout(() => {
              // 重新获取已经插入到DOM中的 quickViewContent 元素
              const quickViewContent = drawerContent.querySelector('.quick-view__content');

              if (quickViewContent) {
                quickViewContent.classList.add('hide-cover');
              } else {
                console.warn('quickViewContent element not found after DOM insertion');
              }
              
              document.dispatchEvent(new CustomEvent('quickview:loaded', {
                detail: {
                  productUrl: this.dataset.productUrl
                }
              }));
            }, 500);
          })
          .catch(e => {
            console.error(e);
          });
      }
      
    }
  )
}